import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, Media, Label, Input, DropdownItem, Form, Row, Col } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import DataTable from 'react-data-table-component';
import { H3, Btn, Breadcrumbs, H4 } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import { Add, Search, Filter, ProAttributes, ProAttributesList } from '../../../Constant';
import { statusAddon, statusAddonRole, viewAttribute, viewAttributeRole, deleteAttribute, deleteAttributeRole, statusAttribute, statusAttributeRole } from '../../../CommonUrl';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Transparentspinner from '../../Common/Loader/Transparentspinner';

const Attribute = () => {
    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' };
    const toggleStyleDelete = { padding: '10px 20px', color: 'red', opacity: '0.8', fontSize: '14px' };
    const [addonLists, setAddonList] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (searchKeyword == '') {
            setLoading(true);
            fetchAddon(1);
        }
    }, [searchKeyword]);


    const attributeColumns = [
        {
            name: <i className="fa fa-gears" style={{ fontSize: '15px' }}></i>,
            selector: row => row.action,
            cell: row => <ActionCell row={row} />,
            sortable: true,
            center: true,
        },
        {
            name: <H4>Name</H4>,
            selector: row => row.Name,
            sortable: true,
            wrap: true,
            sortFunction: (a, b) => {
                const nameA = a?.Name?.toString().toLowerCase() || '';
                const nameB = b?.Name?.toString().toLowerCase() || '';
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            }
        },
        {
            name: <H4>Type</H4>,
            selector: row => row.Type,
            sortable: true,
            wrap: true,
            sortFunction: (a, b) => {
                const nameA = a?.type?.toString().toLowerCase() || '';
                const nameB = b?.type?.toString().toLowerCase() || '';
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            }
        },
        {
            name: <H4>Status</H4>,
            selector: row => row.Status,
            sortable: true,
        },
    ];

    const handleSwitchToggle = async (event, itemId) => {
        const checked = event.target.checked;
        let reqSwitch = null;
        if (checked === false) {
            reqSwitch = { attribute_id: itemId, status: 'inactive' }
        } else {
            reqSwitch = { attribute_id: itemId, status: 'active' }
        }
        const statusChange = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? statusAttribute : statusAttributeRole, reqSwitch);
        if (statusChange.status === 200) {
            if (statusChange.data.status === true) {
                toast.success(statusChange.data.message);
            }
            else {
                toast.error(statusChange.data.message);
            }
        } else if (statusChange.status >= 400 && statusChange.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (statusChange.status >= 500 && statusChange.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    }

    const ActionCell = ({ row }) => {
        const [dropdownOpen, setDropdownOpen] = React.useState(false);
        const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

        const handleEditClick = () => {
            const editFormURL = `${process.env.PUBLIC_URL}${process.env.PUBLIC_URL}/Products/attribute-edit?id=${row.id}`;
            navigate(editFormURL);
        };

        const deleteAddonList = () => {
            SweetAlert.fire({
                title: 'Confirm deletion?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ok',
                cancelButtonText: 'cancel',
                reverseButtons: true
            }).then(async (result) => {
                if (result.value) {
                    const deleteRes = { attribute_id: row.id }
                    const addonDelete = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? deleteAttribute : deleteAttributeRole, deleteRes);
                    if (addonDelete.status === 200) {
                        if (addonDelete.data.status === true) {
                            SweetAlert.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            );
                            fetchAddon();
                        } else {
                            toast.error(addonDelete.data.message);
                        }
                    } else if (addonDelete.status >= 400 && addonDelete.status <= 405) {
                        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
                    } else if (addonDelete.status >= 500 && addonDelete.status <= 505) {
                        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
                    } else {
                        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
                    }
                }
            });
        };

        return (
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle color="#00000" style={{ padding: '6px 12px', fontSize: '14px', zIndex: 1000 }}>
                    <i className="fa fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu container="body">
                    {(authState.userRole === 1 || authState.permissions.includes('edit-attribute')) &&
                        <DropdownItem style={toggleStyle} onClick={() => handleEditClick()}>Edit</DropdownItem>
                    }
                    {(authState.userRole === 1 || authState.permissions.includes('remove-attribute')) &&
                        <DropdownItem style={toggleStyleDelete} onClick={() => deleteAddonList()}>Delete</DropdownItem>
                    }
                </DropdownMenu>
            </Dropdown>
        );
    };


    const handleSearchInputChange = (event) => {
        setSearchKeyword(event.target.value);
    };

    const handleFilterSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        await fetchAddon(); // Fetch addon data
        setLoading(false);
    };


    const fetchAddon = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewAttribute : viewAttributeRole);
        if (response.status === true) {
            setResetPaginationToggle(!resetPaginationToggle);
            if (Array.isArray(response.data)) {
                const filteredAddons = response.data.filter((item) => {
                    const nameMatch = item.title && item.title.toLowerCase().includes(searchKeyword.toLowerCase());
                    const CategoryMatch = item.category_name && item.category_name.toString().toLowerCase().includes(searchKeyword.toLowerCase());
                    return nameMatch || CategoryMatch;
                });
                setAddonList(filteredAddons.map((e, index) => {
                    return {
                        Si: index + 1,
                        Name: e.title,
                        Type: e.type,
                        category_type: e.category_name,
                        id: e.id,
                        Status: <Media body className={`flex-grow-1 text-end icon-state`}>
                            <Label className="switch">
                                <Input type="checkbox"
                                    defaultChecked={e.status === "active" ? true : false}
                                    onChange={(event) => handleSwitchToggle(event, e.id)}
                                />
                                <span className="switch-state" ></span>
                            </Label>
                        </Media>,
                        status: e.status,
                    }
                }))
                setLoading(false)
            }
        } else if (response.status >= 400 && response.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (response.status >= 500 && response.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle={ProAttributes} parent="Products" title={ProAttributes} />
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-25px 0 -40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{ProAttributesList}</H3>
                    <div>
                        <CardBody className="dropdown-basic" >
                            {(authState.userRole === 1 || authState.permissions.includes('store-attribute')) &&
                                <Link to={`${process.env.PUBLIC_URL}/Products/attribute-add`} className="btn btn-primary button-spacing " style={{ marginRight: '4px' }}>{Add}</Link>
                            }
                            {/* <Link to={`${process.env.PUBLIC_URL}/Services/addon-add`} className="btn btn-primary" style={{ marginLeft: '10px' }}>{Add}</Link> */}
                        </CardBody>
                    </div>
                </CardHeader>
                <CardBody>
                    <span className='custom-span'>
                        <Form className="needs-validation" noValidate onSubmit={handleFilterSubmit}>
                            <Row className="ps-3 mb-4 custom-search-filter align-items-center">
                                <Col xs="6" sm="4" md="2" lg="2">
                                    <input className="form-control" placeholder={Search} id="validationCustom01" type="text" value={searchKeyword} onChange={handleSearchInputChange}
                                    />
                                </Col>
                                <Col xs="6" sm="6" md="4" lg="3">
                                    <Btn className="custom-filter-btn" attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                                </Col>
                            </Row>
                        </Form>
                    </span>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={[
                                {
                                    name: <H4>Sl</H4>,
                                    selector: (row, index) => index + 1, // Assign SI dynamically based on current index
                                    width: '60px',
                                    sortable: false, // Disable sorting for SI
                                },
                                ...attributeColumns // All other columns remain the same
                            ]}
                            data={addonLists}
                            pagination
                            defaultSortAsc
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default Attribute;